import { render, staticRenderFns } from "./page.vue?vue&type=template&id=120d5dc2"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120d5dc2')) {
      api.createRecord('120d5dc2', component.options)
    } else {
      api.reload('120d5dc2', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=120d5dc2", function () {
      api.rerender('120d5dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/page.vue"
export default component.exports